import { memo } from 'react';

import { Box } from '../box';
import * as Styled from './table.styles';
import { TableProps } from './table.types';

const TableComponent = <T,>({
	head,
	body,
	width = '100%',
	minWidth,
	height,
	borderTop,
	borderBottom,
	borderLeft,
	borderRight,
	cellPadding,
	align = 'center',
	renderItem,
	className,
	headIcon,
	isHeaderSticky = false,
	background,
	headColor,
	striped = false,
	showDashedBorder,
	errorRow,
	isHeaderBorderTop = true,
}: TableProps<T>) => {
	return (
		<Styled.Table
			width={width}
			minWidth={minWidth}
			height={height}
			className={className}
			borderRight={borderRight}
			borderLeft={borderLeft}
		>
			<Styled.TableHead isHeaderSticky={isHeaderSticky}>
				<Styled.TableRow>
					{head.map((val, index) => (
						<Styled.TableHeader
							key={index}
							cellPadding={cellPadding}
							borderTop={borderTop}
							borderBottom={borderBottom}
							align={align}
							background={background}
							headColor={headColor}
							isHeaderSticky={isHeaderSticky}
							isHeaderBorderTop={isHeaderBorderTop}
						>
							{val && (
								<Box align="center" gap={12}>
									<span>{val}</span>
									{headIcon && headIcon(val)}
								</Box>
							)}
						</Styled.TableHeader>
					))}
				</Styled.TableRow>
			</Styled.TableHead>
			<Styled.TableBody>
				{body.map((row, index) => (
					<Styled.TableRow
						key={index}
						striped={striped}
						showDashedBorder={showDashedBorder && showDashedBorder[index]}
						errorRow={errorRow && errorRow[index]}
					>
						{renderItem(row)}
					</Styled.TableRow>
				))}
			</Styled.TableBody>
		</Styled.Table>
	);
};

export default memo(TableComponent) as typeof TableComponent;
